import config from '@astina/paloma-shop-portal-ui/src/services/PortalConfig';
import { isGranted } from '@astina/paloma-common-ui/src/services/AccessManager';
import WatchlistOrderNotificationSettings from "@/components/WatchlistOrderNotificationSettings.vue";
import InfoNavItems from "@/components/InfoNavItems.vue";
import ContactView from "./views/ContactView.vue";
import ImprintView from "./views/ImprintView.vue";
import { createPortalUiApp } from "@astina/paloma-shop-portal-ui/src/init";
import { initAnalytics } from "./analytics/init";
import icons from '@/icons';
import { sortCountries } from '@/CatalogFilterUtils';
config.headerInfoComponent = InfoNavItems;
config.customRoutes = [
    {
        name: 'contact',
        path: '/contact',
        component: ContactView,
    },
    {
        name: 'imprint',
        path: '/imprint',
        component: ImprintView,
    },
];
config.cartDeliveryDaysMaxWeeksAhead = 12;
config.cartDeliveryLocations = 'show_selected';
config.cartDeliveryDaysVisibleWeeks = 2;
config.articleOrderingUnitSelection = 'deny';
config.watchlistsSharingEnabled = true;
config.watchlistsSharingIcon = 'qrcode-read';
config.productShowPastOrders = true;
config.catalog.defaultView = 'v2';
config.catalog.allowCatalogViewSelection = true;
config.catalog.search.showCategorySuggestions = true;
config.catalog.search.filters = {
    'fishing_zone': {
        sort: sortCountries,
    },
};
config.productDetails.displayDeliveryDays = true;
config.productDetails.redirectToFirstVariant = true;
config.categories.depth = 3;
config.categories.expand = 0;
config.homePendingOrdersComponents = 'both';
config.productAttributes = {
    icons: icons
};
initAnalytics();
const app = createPortalUiApp();
if (isGranted('PORTAL_NOTIFICATIONS_MANAGE')) {
    app.component('miga-watchlist-order-notification-settings', WatchlistOrderNotificationSettings);
    config.extensions.watchlistAccessToken = 'miga-watchlist-order-notification-settings';
}
app.mount('#app');
